import React from 'react';
import { Scale } from 'lucide-react';
import BackButton from '../components/BackButton';
import { useLanguage } from '../contexts/LanguageContext';

const LegalNotice = () => {
  const { t } = useLanguage();

  if (!t) {
    return (
      <div className="p-8 text-center text-red-600">
        ⚠️ Fehler: Sprachdaten konnten nicht geladen werden.
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center space-x-4 mb-8">
        <BackButton />
        <h1 className="text-3xl font-bold text-gray-900">{t('legal.title')}</h1>
      </div>

      <div className="space-y-8">
        <section className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('legal.companyInfo.title')}</h2>
          <div className="space-y-2 text-gray-600">
            <p>{t('legal.companyInfo.name')}</p>
            <p>{t('legal.companyInfo.address')}</p>
            <p>{t('legal.companyInfo.city')}</p>
            <p>{t('legal.companyInfo.postal')}</p>
            <p>{t('legal.companyInfo.email')}</p>
            <p>{t('legal.companyInfo.phone')}</p>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('legal.terms.title')}</h2>
          <div className="prose prose-orange">
            <p>{t('legal.terms.intro')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.terms.acceptance.title')}</h3>
            <p>{t('legal.terms.acceptance.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.terms.account.title')}</h3>
            <p>{t('legal.terms.account.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.terms.privacy.title')}</h3>
            <p>{t('legal.terms.privacy.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.terms.content.title')}</h3>
            <p>{t('legal.terms.content.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.terms.safety.title')}</h3>
            <p>{t('legal.terms.safety.content')}</p>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('legal.privacy.title')}</h2>
          <div className="prose prose-orange">
            <p>{t('legal.privacy.intro')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.privacy.collection.title')}</h3>
            <p>{t('legal.privacy.collection.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.privacy.usage.title')}</h3>
            <p>{t('legal.privacy.usage.content')}</p>
            
            <h3 className="text-lg font-medium mt-4 mb-2">{t('legal.privacy.protection.title')}</h3>
            <p>{t('legal.privacy.protection.content')}</p>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('legal.disclaimer.title')}</h2>
          <div className="prose prose-orange">
            <p>{t('legal.disclaimer.content')}</p>
            <ul className="list-disc pl-5 mt-2 space-y-2">
              {Array.isArray(t('legal.disclaimer.items')) && t('legal.disclaimer.items').map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('legal.contact.title')}</h2>
          <p className="text-gray-600">
            {t('legal.contact.content')}<br />
            {t('legal.companyInfo.email')}<br />
            {t('legal.companyInfo.phone')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default LegalNotice;